<section *ngIf="newsData?.news_type === 'inner_page'" id="latest-news" class="component component--news component--latest-news news latest-news bg-color-white text-color-dark">
	<div class="wrapper">
		<h2 class="component__title text-center" *ngIf="newsData.nb_heading != ''" [innerHtml]="newsData.nb_heading"></h2>
		<div class="masonry-section masonry-section-js news-grid row">
			<div class="grid-sizer-3"></div>
			<div class="col-12 col-sm-6 col-md-4 masonry-item news-grid-item" *ngFor="let newsitem of newsArray">
				<div class="news-grid__item">
					<div class="svg-triangle">
						<svg preserveAspectRatio="none" viewBox="0 0 100 100" width="11px" height="11px">
							<polygon points="0,100 100,100 0,0" fill="#ffffff"></polygon>
						</svg>
					</div>
					<a class="news__link link-target-blank" href="{{ newsitem.news_link }}" *ngIf="newsitem.news_link_ext == 'yes'" target="_blank">
						<figure class="news__image {{ newsitem.news_category == 'Video' ? 'news__video' : '' }}" *ngIf="newsitem.news_image != ''">
							<img alt="{{ newsitem.news_title }}" class="img-responsive" [defaultImage]="newsitem.news_image" [lazyLoad]="newsitem.news_image" loading="lazy" width="342" height="229"/>
						</figure>
						<div class="news__content">
							<span class="news_date" *ngIf="'' != newsitem.news_category">{{newsitem.news_category}}.{{newsitem.news_date}}</span>
							<span class="news_date" *ngIf="'' == newsitem.news_category" [innerHtml]="newsitem.news_date"></span>
							<h3 class="h4">{{ newsitem.news_title }} <i class="icon-link-out"></i></h3>
							<p *ngIf="newsitem.news_excerpt" [innerHtml]="newsitem.news_excerpt"></p>
						</div>
					</a>
					<a class="news__link" routerLink="/{{ newsitem.news_link }}" *ngIf="newsitem.news_link_ext != 'yes'">
						<figure class="news__image {{ newsitem.news_category == 'Video' ? 'news__video' : '' }}" *ngIf="newsitem.news_image != ''">
							<img alt="{{ newsitem.news_title }}" class="img-responsive" [defaultImage]="newsitem.news_image" [lazyLoad]="newsitem.news_image" loading="lazy" width="342" height="229"/>
						</figure>
						<div class="news__content">
							<span class="news_date" *ngIf="'' != newsitem.news_category">{{newsitem.news_category}}.{{newsitem.news_date}}</span>
							<span class="news_date" *ngIf="'' == newsitem.news_category" [innerHtml]="newsitem.news_date"></span>
							<h3 class="h4" [innerHtml]="newsitem.news_title"></h3>
							<p *ngIf="newsitem.news_excerpt" [innerHtml]="newsitem.news_excerpt"></p>
						</div>
					</a>
				</div>
			</div>
		</div>
		<div class="row load-more-news">
			<div class="col-12 text-center load-more link-wrapper load-more-large show"  id="loadnews" (click)="moreNews( newsData.nb_limit, newsData.offset, newsData.news_count )" *ngIf="!error_message_show">
				<a href="javascript:void(0);" class="btn btn-bluelight btn-circle link-more" *ngIf="!loadMoreButton && showMoreButton">See More <span><i class="icon-breadcrumb-bottom"></i></span></a>
				<span *ngIf="loadMoreButton"><span class="loading__circle loading__circle-small"></span></span>
			</div>			
			<div class="alert-login error-message" id="error-message" *ngIf="error_message_show">
				<div class="wrapper">
					<span><p [innerHtml]="error_message"></p></span>
				</div>
			</div>
		</div>
	</div>
</section>